<div class="modal-header">
    <h4 class="modal-title fw-bold" jhiTranslate="inventoryManagerApp.lot.merge.title">Merge lots</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <div class="table-responsive custom-scroll-style" style="max-height: 500px" *ngIf="lots">
        <table class="table table-striped table-bordered table-curved" *ngIf="lots.length else nodata">
            <thead class="sticky-header">
            <tr>
                <th><span jhiTranslate="inventoryManagerApp.lot.merge.keep">Keep</span></th>
                <th><span jhiTranslate="inventoryManagerApp.lot.stockId">Stock ID</span></th>
                <th><span jhiTranslate="inventoryManagerApp.lot.gid">GID</span></th>
                <th *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION"><span jhiTranslate="inventoryManagerApp.lot.designation">Designation</span></th>
                <th><span jhiTranslate="inventoryManagerApp.lot.locationName">Storage Location</span></th>
                <th><span jhiTranslate="inventoryManagerApp.lot.actualBalance">Actual Balance</span></th>
                <th><span jhiTranslate="inventoryManagerApp.lot.unitName">Units</span></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let lot of lots ;trackBy: trackId">
                <td><input class="form-check-input" type="radio" [checked]="isSelected(lot)" (click)="select(lot)" name="lot-merge"></td>
                <td>{{lot.stockId}}</td>
                <td>{{lot.gid}}</td>
                <td *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION">{{lot.designation}}</td>
                <td>{{lot.locationName}}</td>
                <td>{{lot.actualBalance}}</td>
                <td>{{lot.unitName}}</td>
            </tr>
            </tbody>
        </table>
        <ng-template #nodata>
            <table class="table table-striped table-bordered table-curved">
                <thead><tr><th></th></tr></thead><tbody>
            <tr><td jhiTranslate="no.data"></td></tr></tbody>
            </table>
        </ng-template>
    </div>
    <div *ngIf="lots && lots.length">
        <div class="row">
            <div class="col">
                <div class="pagination-container">
                    <div class="pagination-box pagination-box-left">
                        <div>
                            <jhi-item-count-custom [page]="page" [total]="filteredItems" [itemsPerPage]="itemsPerPage"
                                                   [limit]="5000"></jhi-item-count-custom>
                        </div>
                    </div>
                    <div class="pagination-box">
                        <ngb-pagination [collectionSize]="filteredItems" [(page)]="page" [pageSize]="itemsPerPage"
                                        [maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
                    </div>
                    <div class="pagination-box pagination-box-right">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
    </button>
    <button (click)="merge()" [disabled]="!selectedItem" class="btn btn-primary">
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="inventoryManagerApp.lot.merge.action">Merge</span>
    </button>
</div>
